module.exports = __webpack_public_path__ + "img/528.52d76e54.gif";